/** Common UTF-8-as-Latin-1 / Windows-1252 mojibake sequences on Control Bridge paths. */
const MOJIBAKE_REPLACEMENTS: Array<[string, string]> = [
  ['\u00e2\u0080\u0094', '\u2014'], // em dash —
  ['\u00e2\u0080\u0093', '\u2013'], // en dash –
  ['\u00e2\u0080\u0099', '\u2019'], // right single quote '
  ['\u00e2\u0080\u0098', '\u2018'], // left single quote '
  ['\u00e2\u0080\u009c', '\u201c'], // left double quote "
  ['\u00e2\u0080\u009d', '\u201d'], // right double quote "
  ['\u00e2\u0080\u00a6', '\u2026'], // ellipsis …
  // Windows-1252 misread of UTF-8 em/en dash (common in krysalis_central resource profiles)
  ['\u00e2\u20ac\u201d', '\u2014'],
  ['\u00e2\u20ac\u201c', '\u2014'],
  ['\u00e2\u20ac\u0022', '\u2014'],
  ['\u00e2\u20ac\u2013', '\u2013'],
  ['\u00e2\u20ac\u0094', '\u2014'],
  ['\u00e2\u20ac\u0093', '\u2013'],
  ['\u00e2\u20ac\u0099', '\u2019'],
  ['\u00e2\u20ac\u0098', '\u2018'],
  ['\u00e2\u20ac\u009c', '\u201c'],
  ['\u00e2\u20ac\u009d', '\u201d'],
  ['\u00e2\u20ac\u00a6', '\u2026'],
  ['â€"', '\u2014'],
  ['â€“', '\u2013'],
  ['â€™', '\u2019'],
  ['â€˜', '\u2018'],
  ['â€œ', '\u201c'],
  ['â€\u009d', '\u201d'],
  ['â€¦', '\u2026'],
  ['\u00c2\u00b7', '\u00b7'], // Â· → ·
];

function looksLikeMojibake(text: string): boolean {
  return /[âÃÂ][\u0080-\u00bf€]/.test(text) || text.includes('â€') || text.includes('\u00c2');
}

function stripNonprintable(text: string): string {
  return text
    .replace(/[\u0000-\u001F\u007F-\u009F]/g, ' ')
    .replace(/\uFFFD/g, ' ')
    .replace(/ {2,}/g, ' ')
    .trim();
}

/** Re-decode strings where UTF-8 bytes were misread as Latin-1 / Windows-1252. */
function tryLatin1BytesAsUtf8(text: string): string {
  try {
    const bytes = Uint8Array.from(text, (char) => char.charCodeAt(0) & 0xff);
    const decoded = new TextDecoder('utf-8', { fatal: false }).decode(bytes);
    if (decoded && decoded !== text && !decoded.includes('\uFFFD')) {
      return decoded;
    }
  } catch {
    /* keep original */
  }
  return text;
}

function repairReplacementCharDashes(text: string): string {
  return text.replace(/(\S)\s*\uFFFD\s*(\S)/g, '$1 \u2014 $2');
}

/** Repair mojibake in manifest / structure display strings. Idempotent on clean text. */
export function fixUtf8Mojibake(text: string | null | undefined): string {
  if (text == null) return '';
  let value = String(text);
  if (!value) return value;

  value = repairReplacementCharDashes(value);
  if (!looksLikeMojibake(value) && !value.includes('\uFFFD')) {
    return stripNonprintable(value);
  }

  for (const [bad, good] of MOJIBAKE_REPLACEMENTS) {
    if (value.includes(bad)) {
      value = value.split(bad).join(good);
    }
  }

  if (looksLikeMojibake(value)) {
    value = tryLatin1BytesAsUtf8(value);
    for (const [bad, good] of MOJIBAKE_REPLACEMENTS) {
      if (value.includes(bad)) {
        value = value.split(bad).join(good);
      }
    }
  }

  return stripNonprintable(value);
}
